import Skeleton from "react-loading-skeleton";

const HomeCompetitionsLoader = () => (
  <div className={"mt-6 lg:mt-10 gap-[32px] mx-auto mb-[40px] w-full max-w-[1360px] xs:px-2 md:px-5 relative"}>
    <div className="flex flex-col items-start gap-1 mb-4 lg:mb-6">
      <h1 className="text-dark-1 font-jost text-base font-bold leading-[22px] lg:text-2xl lg:leading-[30px] uppercase blur-[4px] opacity-10">
        Featured Competitions
      </h1>
    </div>
    <div
      className={
        "grid xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 2lg:grid-cols-4 xs:gap-2 md:gap-4 justify-content-center"
      }>
      <div className={"col-span-2 rounded-lg overflow-hidden"}>
        <Skeleton
          count={1}
          inline
          highlightColor="#fff"
          containerClassName={"block"}
          className="w-full min-h-[332px] lg:min-h-[488px] !rounded-lg overflow-hidden"
        />
      </div>
      {[...Array(6)].map((_, index) => (
        <div key={index} className={""}>
          <Skeleton
            count={1}
            inline
            highlightColor="#fff"
            containerClassName={"block"}
            className="w-full min-h-[332px] lg:min-h-[488px] !rounded-lg overflow-hidden"
          />
        </div>
      ))}
    </div>
  </div>
);

export default HomeCompetitionsLoader;
